module.exports = __webpack_public_path__ + "static/media/invision.fecc7812.svg";